<template>
    <section class="row mt-3 section-partners">
        <div class="container">
            <div class="col-12">
                <div class="row">
                    <h1 class="section-title">Đối tác</h1>
                </div>
            </div>
            <div class="col-12 mt-1">
                <div class="slider-partners">
                    <img :src="assetsBaseUrl + itemValue.filePath" v-for="(itemValue, itemIndex) in partnersSliderItemsList" :key="'item' + itemIndex">
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    /**
     * Import helpers
     */
    import {
        createPartnersSlider
    } from '../helpers/slick';

    export default {
        name: "PartnersComponent",
        data() {
            return {
                assetsBaseUrl: process.env.VUE_APP_API_DOMAIN + process.env.VUE_APP_ASSETS_PATH + '/',
                partnersSliderItemsList: null
            }
        },
        mounted() {
            // get top-slider items list
            this.partnersSliderItemsList = this.$store.state.sliders.partnersSlider.itemsList;
            /**
             * Create partners slider
             */
            $(document).ready(function() {
                createPartnersSlider();
            })
        }
    }
</script>

<style scoped>

</style>
